import React, { FC, memo } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { green, red, blue, orange } from '@material-ui/core/colors';
import { AmountCellData } from 'src/redux/slices/customer-payment';
import { formatCurrency } from 'src/utils';

interface Props {
  data: AmountCellData;
}

const Component: FC<Props> = ({ data }) => {
  const getBalanceColor = (balance: number | undefined) => {
    if (balance === undefined) return 'inherit';
    if (balance <= 0) return green[500];
    if (balance > 0) return red[500];
    return orange[500];
  };

  return (
    <Box>
      <Typography style={{ color: blue[700] }}>
        {`Total Retail Price: ${formatCurrency(data?.total_retail_price)}`}{' '}
      </Typography>
      <Divider style={{ margin: '10px 0px' }} />
      <Typography style={{ color: green[700] }}>
        {`Amount Paid: ${formatCurrency(data?.amount_paid)}`}{' '}
      </Typography>
      <Typography style={{ color: getBalanceColor(data?.balance) }}>
        {`Balance: ${formatCurrency(data?.balance)}`}{' '}
      </Typography>
      <Divider style={{ margin: '10px 0px' }} />
      <Typography style={{ color: blue[500] }}>
        {`Total Payments: ${formatCurrency(data?.total_payments)}`}{' '}
      </Typography>
      <Typography style={{ color: orange[700] }}>
        {`Total Sales: ${formatCurrency(data?.total_sales)}`}{' '}
      </Typography>{' '}
    </Box>
  );
};

export const AmountCell = memo(Component);
